var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbsdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.66667H12.3333C13.0697 9.66667 13.6667 9.06971 13.6667 8.33333V2.33333C13.6667 1.59695 13.0697 1 12.3333 1H11C10.2636 1 9.66666 1.59695 9.66666 2.33333V8.33333C9.66666 9.06971 10.2636 9.66667 11 9.66667Z",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.41539 1H6.85925C7.38572 1 7.90041 1.15583 8.33846 1.44787L9.36979 2.13542C9.55526 2.25907 9.66666 2.46722 9.66666 2.69012V8.15629C9.66666 8.27231 9.63638 8.38632 9.57882 8.48705L6.99999 13H6.11418C4.78303 13 3.98904 11.5164 4.72743 10.4088L5.66666 9H2.04102C1.1736 9 0.537119 8.18482 0.747501 7.34329L1.82835 3.0199C2.12512 1.83279 3.19175 1 4.41539 1Z",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsdown);
export default __webpack_public_path__ + "static/media/thumbsdown.77181dd51580714e426e64d79ce9660d.svg";
export { ForwardRef as ReactComponent };